import { render, staticRenderFns } from "./GameClassRegisterRow.vue?vue&type=template&id=537a890b&scoped=true"
import script from "./GameClassRegisterRow.vue?vue&type=script&lang=js"
export * from "./GameClassRegisterRow.vue?vue&type=script&lang=js"
import style0 from "./GameClassRegisterRow.vue?vue&type=style&index=0&id=537a890b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a890b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VListItemTitle})
